const binding = { modules: {}, dataActions: {} };

    (binding.modules['lobas-inline-script'] = {
        c: () => require('partner/modules/lobas-inline-script/lobas-inline-script.tsx'),
        $type: 'scriptModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'lobas-inline-script',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/lobas-inline-script'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };